import { render, staticRenderFns } from "./newHome3.vue?vue&type=template&id=325b2999&scoped=true&"
import script from "./newHome3.vue?vue&type=script&lang=js&"
export * from "./newHome3.vue?vue&type=script&lang=js&"
import style0 from "./newHome3.vue?vue&type=style&index=0&lang=less&"
import style1 from "./newHome3.vue?vue&type=style&index=1&id=325b2999&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325b2999",
  null
  
)

export default component.exports